import { Pipe, PipeTransform } from '@angular/core';
import { QrCode } from '../models';

@Pipe({
  name: 'qrIdList',
  standalone: true,
})
export class QrIdListPipe implements PipeTransform {
  transform(qrDataList: QrCode[]): string[] {
    return qrDataList?.map((x) => x.qrCodeId) ?? [];
  }
}
